import React, { Component } from "react";
import _ from "lodash";
import Radium from "radium";
import COLOURS from "util/colours";
import {
  DiscordIcon,
  ThreadsIcon,
  TikTokIcon,
  XIcon,
  YouTubeIcon,
} from "visual-components/socialGrowth/icons";

const contentMap = {
  linkShare: {
    faIcon: "fa-bullhorn",
    iconPadding: "1px",
    backgroundColor: COLOURS.instagram,
  },
  fbLike: {
    faIcon: "fa-facebook",
    iconPadding: "0",
    backgroundColor: COLOURS.fbBlue,
  },
  fbShare: {
    faIcon: "fa-facebook",
    iconPadding: "0",
    backgroundColor: COLOURS.fbBlue,
  },
  instagramFollow: {
    faIcon: "fa-instagram",
    iconPadding: "1px",
    backgroundColor: COLOURS.instagramGradient,
  },
  instagramVisit: {
    faIcon: "fa-instagram",
    iconPadding: "1px",
    backgroundColor: COLOURS.instagramGradient,
  },
  youtubeWatch: {
    // faIcon: "fa-youtube-play",
    iconComponent: <YouTubeIcon color="white" size={24} />,
    iconPadding: "0",
    backgroundColor: COLOURS.youtubeRed,
  },
  youtubeSubscribe: {
    // faIcon: "fa-youtube-play",
    iconComponent: <YouTubeIcon color="white" size={24} />,
    iconPadding: "0",
    backgroundColor: COLOURS.youtubeRed,
  },
  pinterestFollow: {
    faIcon: "fa-pinterest-p",
    iconPadding: "1px",
    backgroundColor: COLOURS.pinterestRed,
    label: "Follow Us On Pinterest",
  },
  pinterestPin: {
    faIcon: "fa-pinterest-p",
    iconPadding: "1px",
    backgroundColor: COLOURS.pinterestRed,
  },
  snapchatFollow: {
    faIcon: "fa-snapchat-ghost",
    iconPadding: "1px",
    backgroundColor: COLOURS.snapchatYellow,
  },
  appDownload: {
    faIcon: "fa-download",
    iconPadding: "1px",
    backgroundColor: COLOURS.instagram,
  },
  tiktokFollow: {
    // faIcon: "fa-tiktok",
    iconComponent: <TikTokIcon size={24} />,
    iconPadding: "0",
    backgroundColor: COLOURS.tiktok,
  },
  tiktokShare: {
    // faIcon: "fa-tiktok",
    iconComponent: <TikTokIcon size={24} />,
    iconPadding: "0",
    backgroundColor: COLOURS.tiktok,
  },
  xFollow: {
    // faIcon: "fa-x-twitter",
    iconComponent: <XIcon size={24} />,
    iconPadding: "0",
    backgroundColor: COLOURS.xBlack,
  },
  xShare: {
    // faIcon: "fa-x-twitter",
    iconComponent: <XIcon size={24} />,
    iconPadding: "0",
    backgroundColor: COLOURS.xBlack,
  },
  linkedinFollow: {
    faIcon: "fa-linkedin",
    iconPadding: "1px",
    backgroundColor: COLOURS.linkedin,
  },
  linkedinShare: {
    faIcon: "fa-linkedin",
    iconPadding: "1px",
    backgroundColor: COLOURS.linkedin,
  },
  whatsappShare: {
    faIcon: "fa-whatsapp",
    iconPadding: "1px",
    backgroundColor: COLOURS.whatsapp,
  },
  discordJoin: {
    // faIcon: "fa-discord",
    iconComponent: <DiscordIcon size={24} />,
    iconPadding: "0",
    backgroundColor: COLOURS.discord,
  },
  twitchFollow: {
    faIcon: "fa-twitch",
    iconPadding: "1px",
    backgroundColor: COLOURS.twitch,
  },
  threadsFollow: {
    // faIcon: "fa-threads",
    iconComponent: <ThreadsIcon size={24} />,
    iconPadding: "0",
    backgroundColor: COLOURS.threads,
  },
};

class BonusItem extends Component {
  render() {
    const bonus = _.merge({}, { bonusCount: "2" }, this.props.bonus);
    let props = {};

    _.each(bonus, (value, key) => {
      props["data-" + key.toLowerCase()] = value;
    });

    const bonusKeyHtml = this.props.bonusKey.toLowerCase();

    props["data-bonuskey"] = bonusKeyHtml;

    const faIcon = contentMap[this.props.bonusKey]?.faIcon;
    const iconComponent = contentMap[this.props.bonusKey]?.iconComponent;

    let isEven = this.props.index % 2 === 0;

    let outerDivClasses;
    let outerDivStyles;

    if (this.props.largeCTA) {
      outerDivClasses = "col-xs-12 col-sm-12 col-md-6 col-lg-6";
      outerDivStyles = {
        borderRightStyle: "dotted",
        borderRightWidth: "1px",
        borderRightColor: "transparent",
        borderLeftStyle: "solid",
        borderLeftWidth: "1px",
        borderLeftColor: "transparent",
        "@media only screen and (min-width: 992px)": {
          borderRightColor: isEven ? COLOURS.darkGreen.point1 : "transparent",
        },
      };
    } else {
      outerDivClasses = "col-xs-12 col-sm-12 col-md-12 col-lg-12";
      outerDivStyles = {};
    }

    //const ineligableTypes = ["fbLike", "fbShare", "instagramFollow"];
    const ineligableTypes = [];

    if (bonus.hidden) {
      return <></>;
    }

    let bonusCount =
      parseInt(bonus.bonusCount) && ineligableTypes.indexOf(this.props.bonusKey) === -1
        ? `+ ${bonus.bonusCount}`
        : "";

    if (this.props.bonusKey === "linkShare") {
      bonusCount += " each";
    }

    return (
      <div className={outerDivClasses} style={outerDivStyles}>
        <div {...props} className={`text-center bonus-item ${bonusKeyHtml}`}>
          <div
            className="row"
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "-15px",
              marginRight: "-15px",
              borderTopStyle: "solid",
              borderTopColor: "#e0f2e9",
              borderTopWidth: "2px",
              borderBottom: "none",
            }}
          >
            <div
              className="col-xs-8 col-lg-9 text-left"
              style={{
                paddingTop: "15px",
                paddingRight: "0",
                paddingBottom: "15px",
                paddingLeft: "0",
              }}
            >
              <div className="row" style={{ display: "flex", alignItems: "center" }}>
                <div
                  className="col-xs-4 col-lg-3"
                  style={{
                    paddingLeft: "9px",
                    "@media only screen and (min-width: 768px)": {
                      paddingLeft: "5%",
                    },
                  }}
                >
                  <div
                    style={{
                      background: contentMap[this.props.bonusKey]?.backgroundColor,
                      paddingTop: "8px",
                      paddingRight: "0",
                      paddingBottom: "7px",
                      paddingLeft: contentMap[this.props.bonusKey]?.iconPadding,
                      borderRadius: "20px",
                      width: "40px",
                      height: "40px",
                      display: "inline-block",
                      marginLeft: "15px",
                      marginRight: "15px",
                      textAlign: "center",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    }}
                  >
                    {faIcon && (
                      <i
                        className={`fa ${faIcon} text-2xl`}
                        aria-hidden="true"
                        style={{
                          color: COLOURS.white,
                          fontSize: "24px",
                        }}
                      />
                    )}
                    {iconComponent && <>{iconComponent}</>}
                  </div>
                </div>
                <div
                  className="col-xs-8 col-lg-9"
                  style={{
                    paddingLeft: "5px",
                  }}
                >
                  <small
                    style={{
                      margin: "0",
                      fontSize: "14px",
                      lineHeight: "20px",
                      fontFamily: "Larsseit-Thin",
                      color: COLOURS.textGrey,
                      display: "inline",
                    }}
                  >
                    {bonus.message}
                  </small>
                </div>
              </div>
            </div>
            <div
              className="col-xs-4 col-lg-3 pull-right"
              style={{
                paddingLeft: "0",
                paddingRight: "0",
                display: "table",
              }}
            >
              <div
                style={{
                  display: "table-cell",
                  verticalAlign: "middle",
                  height: "50px",
                  textAlign: "right",
                }}
              >
                <div
                  className="bonus-count"
                  style={{
                    marginBottom: "0",
                    marginRight: "8px",
                    display: "block",
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: "#2d6e4e",
                  }}
                >
                  {bonusCount}

                  <span
                    className="check"
                    style={{
                      fontFamily: "Larsseit-Thin",
                      color: COLOURS.textGrey,
                      fontSize: "20px",
                      marginLeft: "8px",
                    }}
                  >
                    <i
                      className="fa fa-check"
                      aria-hidden="true"
                      style={{
                        color: COLOURS.medGreen.full,
                      }}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Radium(BonusItem);
